import React, { useEffect, useMemo, useRef, useState } from 'react'
import { ContenedorParametros } from '../../components/utils/ContenedorParametros'
import { BotonProcesar } from '../../components/buttons/BotonProcesar';
import { useDisenoRuta } from '../../../hooks/gestionOperacional/useDisenoRuta';
import PantallaCargaInterna from '../../components/forms/PantallaCargaInterna';
import { Modal } from '../../components/modal/Modal';
import { useModal } from '../../../hooks/useModal';
import { utilLeaflet } from '../../../utils/utilLeaflet';
import '../../../assets/css/GestionOperacional/DisenoRuta.css'

export const GestionDisenoRutas = () => {
	const leafLetClass = useMemo(() => new utilLeaflet(), []);
	const refMap = useRef(null)

	const hookDisenoRutas = useDisenoRuta()

	const [estaCargando, setEstaCargando] = useState([])
	const [arrItinerario, setArrItinerario] = useState([])
	const [textoModal, setTextoModal] = useState('')
	const [coordenadasRegistro, setCoordenadasRegistro] = useState([])

	const [isOpenModalItinerario, openModalItinerario, closeModalItinerario] = useModal()
	const [isOpenModalMapa, openModalMapa, closeModalMapa] = useModal()

	useEffect(() => {
		(async () => {
			await listarTabla()
		})()
	},[])

	useEffect(() => {
		if(isOpenModalMapa){
			leafLetClass.inicializarMapa({
				mapDiv: refMap.current
			})
			leafLetClass.map.on('click', (e) => {
				const { lat, lng } = e.latlng;
				const marcador = leafLetClass.crearMarcador({
					lat: lat,
					lng: lng
				})
				setCoordenadasRegistro(valAnterior => {
					return [...valAnterior, {
						latitud: lat,
						longitud: lng,
						coordenadas : lat + ' , ' + lng,
						marcador: marcador
					}]
				})
			})
			leafLetClass.map.getContainer().style.cursor = 'pointer'	// CURSOR POINTER EN EL MAPA
		}

		return () => {
			leafLetClass.map && leafLetClass.map.remove();
			leafLetClass.map = null
			setCoordenadasRegistro([]);
		}
	},[isOpenModalMapa])

	useEffect(() => {
		console.log("isOpenModalMapa -> ", isOpenModalMapa, leafLetClass.map)
		if(isOpenModalMapa && leafLetClass.map){
			console.log("entro a la funcion")
			leafLetClass.eliminarTodasLasPolilineas()
			leafLetClass.crearPolilinea({
				arrPuntos: coordenadasRegistro.map(data => [data.latitud, data.longitud]),
				
			})
		}
	},[coordenadasRegistro])

	const listarTabla = async () => {
		setEstaCargando(true)
		await hookDisenoRutas.listarRutasATU()
		setEstaCargando(false)
	}

	return (
		<>
		{estaCargando ? <PantallaCargaInterna></PantallaCargaInterna> : <></>}
		<div className='w-full h-full flex flex-col'>
			<ContenedorParametros titulo='Ruta y diseño de recorrido'>
					<div className='flex gap-5 items-center'>
							<BotonProcesar onClick={listarTabla}></BotonProcesar>
					</div>
			</ContenedorParametros>
			
			<div className='flex-grow overflow-auto containerScroll'>
				<table id="tablaDisenoRuta" className='table'>
					<thead>
						<tr>
							<th rowSpan={2}>Nº</th>
							<th rowSpan={2}>RUTA ATU</th>
							<th colSpan={2}>DISTRITOS</th>
							<th colSpan={2}>ITINERARIO</th>
							<th rowSpan={2}>CATEGORIA CARROCERIA</th>
							<th colSpan={3}>FLOTA</th>
							<th colSpan={3}>LONGITUD</th>
							<th rowSpan={2}>INTERVALO DE PASO</th>
							<th rowSpan={2}>PUNTO INICIAL</th>
							<th rowSpan={2}>PUNTO FINAL</th>
							<th rowSpan={2}></th>
						</tr>
						<tr>
							<th>ORIGEN</th>
							<th>DESTINO</th>
							<th>IDA</th>
							<th>VUELTA</th>
							<th>OPERATIVA</th>
							<th>RESERVA</th>
							<th>TOTAL</th>
							<th>IDA (Km)</th>
							<th>VUELTA (Km)</th>
							<th>RECORRIDO (Km)</th>
						</tr>
					</thead>
					<tbody>
						{
							hookDisenoRutas.infoRutas.length != 0
							? hookDisenoRutas.infoRutas.map((data,i) => (
								<tr key={i+1}>
									<td>{i+1}</td>
									<td>{data.Ruta}</td>
									<td>{data.DistritoOrigen}</td>
									<td>{data.DistritoDestino}</td>
									<td>
										{
											data.ItinerarioIda
											?	<div onClick={() => {openModalItinerario(); setArrItinerario(data.ItinerarioIda.split(',')); setTextoModal(`ida [Ruta: ${data.Ruta}]`)}} className='flex items-center gap-2'>
													<div className='whitespace-nowrap text-ellipsis overflow-hidden max-w-[120px]'>{data.ItinerarioIda}</div><i className="fa fa-search-plus" aria-hidden="true"></i>
												</div>
											: '-'
										}
									</td>
									<td>
										{
											data.ItinerarioVuelta
											?	<div onClick={() => {openModalItinerario(); setArrItinerario(data.ItinerarioVuelta.split(',')); setTextoModal(`vuelta [Ruta: ${data.Ruta}]`)}} className='flex items-center gap-2'>
													<div className='whitespace-nowrap text-ellipsis overflow-hidden max-w-[120px]'>{data.ItinerarioVuelta}</div><i className="fa fa-search-plus" aria-hidden="true"></i>
												</div>
											:	'-'
										}
										
									</td>
									<td>{data.CarroceriaCategoria}</td>
									<td>{data.FlotaOperativa}</td>
									<td>{data.FlotaReserva}</td>
									<td>{data.TotalFlota}</td>
									<td>{data.LongitudIda}</td>
									<td>{data.LongitudVuelta}</td>
									<td>{data.LongitudRecorrido}</td>
									<td>{data.IntervaloPaso}</td>
									<td>{data.PuntoInicial}</td>
									<td>{data.PuntoFinal}</td>
									<td><button onClick={openModalMapa} className='rounded bg-blue-600 w-[25px] h-[25px]'><i className='fas fa-edit'></i></button></td>
								</tr>
							))
							:	<tr><td colSpan={17} className='text-center'>No hay información para mostrar...</td></tr>
						}
					</tbody>
				</table>
			</div>
		</div>

		<Modal
			title={`Itinerario ${textoModal}`}
			isOpen={isOpenModalItinerario}
			closeModal={closeModalItinerario}
			validButton={{confirm: false,denied:true}}
			textButtons={{denied: 'Cerrar'}}
		>
			<div className='max-h-[400px] overflow-auto containerScroll'>
				<table className='table'>
					<tbody>
						{
							arrItinerario.map((data, i) => (
								<tr key={i+1}>
									<td>{data}</td>
								</tr>
							))
						}
					</tbody>
				</table>
			</div>
		</Modal>

		<Modal
			title={'Registro de recorrido'}
			isOpen={isOpenModalMapa}
			closeModal={closeModalMapa}
		>
			<div className='flex gap-4 h-[500px]'>
				<div ref={refMap} className='w-[600px] shadow-md shadow-white'></div>
				<div className='h-full w-[250px] overflow-auto containerScroll'>
					<table className='table'>
						<thead>
							<tr>
								<th>Nº</th>
								<th>COORDENADAS</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{
								coordenadasRegistro.length == 0
								?	<tr><td colSpan={3} className='text-center'>No hay coordenadas por mostrar ...</td></tr>
								:	coordenadasRegistro.map((data, i) => (
										<tr key={i+1}>
											<td className='text-center'>{i+1}</td>
											<td className='text-center'>{data.coordenadas}</td>
											<td className='text-center'><i onClick={() => {
												leafLetClass.eliminarMarcador(data.marcador)
												setCoordenadasRegistro(coordenadasRegistro.filter(elem => elem.marcador != data.marcador))
											}} className='fas fa-trash text-red-600'></i></td>
										</tr>
									))
							}
						</tbody>
					</table>
				</div>
			</div>
		</Modal>
		</>
	)
}
